module.exports = __webpack_public_path__ + "static/AasthaJ-66a8a1b2135295e6ef32a66763678d70.jpg";